export default __webpack_public_path__ + "images/c71286241dcb2374132085d2083fe5e9.png";